// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 引入 element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 全局错误处理
import { setupErrorHandler } from '@/plugins/errorHandler'

// 引入全局样式
import '@/styles/index.scss'

// 路由
import router, { setupRouter } from '@/router'

// 指令
import { setupAuth, setupMountedFocus } from '@/directives'

import { createApp } from 'vue'

import App from './App.vue'

// 全局路由守卫（权限 + 动态路由）
import './permission'

import Logger from '@/utils/Logger'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  // 尽早注册全局错误处理，避免后续初始化阶段的错误无人兜底
  setupErrorHandler(app)

  await setupI18n(app)

  setupStore(app)

  setupElementPlus(app)

  setupRouter(app)

  // directives 指令
  setupAuth(app)
  setupMountedFocus(app)

  await router.isReady()

  app.mount('#app')
}

setupAll()

Logger.prettyPrimary(`欢迎使用`, import.meta.env.VITE_APP_TITLE)
